import '@fontsource-variable/inter'
import '@fontsource-variable/bricolage-grotesque'
import './styles/index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { loadCatalog } from '@/catalog/load'
import { router } from './router'

// Start fetching the catalog in parallel with the first render.
loadCatalog().catch(() => {
  // Surfaced by the route error boundary when a page reads the catalog.
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
